import dom from "../../dist/jsx-render/dom"
import JSXComponent from "../../dist/jsx-render/JSXComponent"
import { app } from "../Frame/App";
import { IPopupResult, PopupResults } from "./IPopupResult";

declare global {
    interface Window {
        msoPopups: Array<PagePopup>;
    }
}

export type PopupCloseType = "save" | "cancel" | "delete";

class CloseButton extends JSXComponent {
    props: {
        onCloseClicked: (ev: Event) => void;
    }

    render() {
        const button =
            <button type="button" className="close" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>;
        button.addEventListener("click", this.props.onCloseClicked);
        return button;
    }
}

class ContentFrame extends JSXComponent {
    props: {
        onLoaded: () => void;
        url: string;
    }

    render(): HTMLElement {
        const iframe = <iframe id="testIframe" src={app.resolveUrl(this.props.url)} style={{ border: "none" }}></iframe>;
        return iframe;
    }
}

export type PopupProps = {
    url: string;
    resultId?: number;
    fullScreen?: boolean;
    onLoaded?: () => void;
    onBeforeSubmit?: () => boolean;
    onClose?: (reason: PopupCloseType, id: number) => boolean;
    onDelete?: () => boolean;
    showCloseButton?: boolean;
    onSave?: (event: Event) => boolean;
    title?: string;

    /** This is a string id that can be given to a popup on its creation. It will be used to identify this popup, when a descendant Popup (meaning 
     * a Popup that was opnend out of this one) has this Popup's popupId as ancestorId to execute the onCloseDescendant handler.
     */
    popupId?: string;

    /** This is the string id of the ancestor, whose onCloseDescendant handler should be called, when this popup is closed. 
     * Only when this is set will a given onCloseDescendant be called. If an onCloseDescendant is given but no ancestor Id, 
     * this function reference will just be passed to the next opened PagePopup. */
    ancestorId?: string;

    /**
     * This function reference will be executed, when another popup, that is opened on top of this one, knows this popup's popupId and is closed.
     * @param reason
     * @param id
     * @returns
     */
    deferredOnClose?: (reason: PopupCloseType, id: number) => void;
}

export class PagePopup extends JSXComponent {
    props: PopupProps;
    private zIndex: number;
    private maxwidth: string;
    private maxheight: string;
    private margin: string;
    private top: string;
    private transform: string;

    private element: HTMLElement;
    public constructor(props: PopupProps) {
        super(props);

        if (this.props.url) {
            this.props.url = this.createUrl(this.props.url);

            // get root window
            const rootWindow = PagePopup.getRootWindow();
            this.zIndex = 2000 + 1000 * rootWindow.msoPopups.length;


            rootWindow.document.body.appendChild(this.render());
            rootWindow.msoPopups.push(this);
        }
    }

    public createUrl(url: string): string {
        let result = url;
        if (url.indexOf('?') >= 0) {
            result += "&isPopup=1&jsxPopup=1";
        }
        else {
            result += "?isPopup=1&jsxPopup=1";
        }
        if (this.props.fullScreen) {
            result += "&fullscreen=1";
        }
        return result;
    }

    public setResultId(value: number) {
        this.props.resultId = value;
    }

    public reload(url) {
        const iFrame = this.element.getElementsByTagName("iframe").item(0);
        iFrame.src = url;
    }

    public reloadSamePage() {
        const iFrame = this.element.getElementsByTagName("iframe").item(0);
        iFrame.contentWindow.location.reload();

        //iFrame.src = iFrame.src;
    }

    public static save(): void {
        app.showWaitPanel();
        const popup = this.getActivePopup();
        if (popup.props.onBeforeSubmit) {
            if (!popup.props.onBeforeSubmit()) {
                app.hideWaitPanel();
                return;
            }
        }

        $.post('', $('form').serialize(), (result: IPopupResult) => {
            if (result.result == PopupResults.Success) {
                popup.reloadSamePage();
            }
            else if (result.result == PopupResults.Error) {
                app.hideWaitPanel();
                for (let msg of result.messages) {
                    app.addError(msg);
                }
            }
        });
    }

    public static saveAndClose(): void {
        app.showWaitPanel();
        const popup = this.getActivePopup();
        if (popup.props.onBeforeSubmit) {
            if (!popup.props.onBeforeSubmit()) {
                app.hideWaitPanel();
                return;
            }
        }

        $.post('', $('form').serialize(), (result: IPopupResult) => {
            if (result.result == PopupResults.Success) {
                popup.setResultId(result.id);
                popup.close("save");
            }
            else if (result.result == PopupResults.Error) {
                app.hideWaitPanel();
                for (let msg of result.messages) {
                    app.addError(msg);
                }
            }
        });
    }

    public static saveWithoutReload(): void {
        app.showWaitPanel();
        const popup = this.getActivePopup();
        if (popup.props.onBeforeSubmit) {
            if (!popup.props.onBeforeSubmit()) {
                app.hideWaitPanel();
                return;
            }
        }

        $.post('', $('form').serialize(), (result: IPopupResult) => {
            app.hideWaitPanel();
            if (result.result == PopupResults.Success) {
                console.log("success");
                popup.setResultId(result.id);
                // DA do not reload, keep the current page open. If this causes any problems, add a reload = true/false parameter to the save button.
                //popup.reloadSamePage();
            }
            else if (result.result == PopupResults.Error) {
                for (let msg of result.messages) {
                    app.addError(msg);
                }
            }
        });
    }

    public static cancel(): void {
        const popup = this.getActivePopup();
        popup.close("cancel");
    }

    public static delete(): void {
        const popup = this.getActivePopup();
        if (popup.props.onDelete) {
            if (popup.props.onDelete()) {
                popup.close("delete");
            }
        }
        else {
            app.addError("Popup.delete: no onDelete callback registered!");
        }
    }

    public close = (reason: PopupCloseType) => {
        app.cleanIndexUrl();

        if (this.props.onClose) {
            if (!this.props.onClose(reason, this.props.resultId)) {
                return;
            }
        }

        if (this.props.ancestorId) {
            let ancestor = this.getAncestorById();
            if (ancestor) {
                ancestor.props.deferredOnClose(reason, this.props.resultId);
            }
        }

        this.element?.parentElement?.removeChild(this.element);

        const rootWindow = PagePopup.getRootWindow();
        rootWindow.msoPopups.pop();
    }


    public static getActivePopup(): PagePopup {
        const rootWindow = PagePopup.getRootWindow();
        return rootWindow.msoPopups[rootWindow.msoPopups.length - 1];
    }

    public getAncestorById = () => {
        const rootWindow = PagePopup.getRootWindow();
        const activePopup = PagePopup.getActivePopup();

        let activePopupIndex = rootWindow.msoPopups.indexOf(activePopup);
        if (activePopupIndex > 0) {
            for (let i: number = activePopupIndex - 1; i >= 0; i--) {
                let popup = rootWindow.msoPopups[i];
                if (popup.props.popupId == this.props.ancestorId) {
                    return rootWindow.msoPopups[i];
                }
            }
        }
        return null;
    }

    public setTitle(value: string) {
        const iFrame = this.element.getElementsByTagName("iframe").item(0);
        if (iFrame) {
            let subTitle = iFrame.contentWindow.document.getElementById("_layoutSubTitle");
            if (!subTitle) {
                subTitle = this.element.getElementsByClassName("popup-title").item(0) as HTMLElement;
                if (!subTitle) {
                    alert("Popup.setTitle: title control not found");
                    return;
                }
            }
            subTitle.innerText = value;
        }
        else {
            alert("Popup.setTitle: iframe not found");
            return;
        }
    }

    public static getRootWindow(): Window {
        let rootWindow: Window = window;
        while (rootWindow.parent && rootWindow.parent.msoPopups && rootWindow != rootWindow.parent) {
            rootWindow = rootWindow.parent;
        }
        return rootWindow;
    }

    private onCloseClicked = () => {
        this.close("cancel");
    }

    private onSaveClicked = (event: Event) => {
        if (this.props.onSave) {
            this.props.onSave(event);
        }
    }

    contentFrame: HTMLIFrameElement;

    createContentFrame(): HTMLIFrameElement {
        this.contentFrame = <ContentFrame url={this.props.url} onLoaded={this.props.onLoaded} />
        return this.contentFrame;
    }

    public show() {
        this.element.style.display = "";
    }

    public hide() {
        this.element.style.display = "none";
    }

    render(): HTMLElement {
        if (this.props.fullScreen) {
            this.element =
                <div className="popup-background" style={{ "z-index": this.zIndex }}>
                    <div className="popup-fullscreen">
                        {this.createContentFrame()}
                    </div>
                </div>
        }
        else {
            this.element =
                <div className="popup-background" style={{ "z-index": this.zIndex }}>
                    <div className="popup-frame">
                        <div className="popup-content" style={{ "max-width": this.maxwidth, "max-height": this.maxheight, "margin": this.margin, "top": this.top, "transform": this.transform }}>
                            <div className="popup-header">
                                <div id="_popupTitle" className="popup-title">{this.props.title}</div>
                                {this.props.showCloseButton === false
                                    ? []
                                    : <CloseButton onCloseClicked={this.onCloseClicked} />}
                            </div>
                            <div className="popup-body">
                                {this.createContentFrame()}
                            </div>
                        </div>
                    </div>
                </div>;


            let saveBtnElement = this.element.querySelector(".save-button") as HTMLButtonElement;
            saveBtnElement?.addEventListener('click', this.onSaveClicked);
        }

        let iFrame = this.element.querySelector("iframe");

        if (iFrame && this.props.onLoaded) {
            iFrame.addEventListener("load", this.props.onLoaded);
        }

        return this.element;
    }
}